export const STATUS_TYPS = {
  0: { text: '未接入', color: 'info' },
  1: { text: '已接入', colorr: 'success' }
};
